import packageJson from '../../package.json';

export default {
  okta: {
    baseUrl: 'https://tempus.okta.com',
    issuer: 'aus5jiu98d2ssknzd297',
    clientId: '0oaywpv3i7Pvv3BNC297',
  },
  // Of this object, only the values are used; the keys are just for documentation.
  authorizedClientIds: {
    clinicalPortal: '0oa1ezb8h9tXssNKS297',
    clinicalPortalDemo: '0oa1r6lw5q9ibRhwY297',
    lens: '0oaunisj3cUBNG5PA296',
    lensNotebook: '0oa2o3gf06ElSNg8f297',
    lensGlassDemo: '0oaio5otptoYXac380h7',
    accountUi: '0oaywpv3i7Pvv3BNC297',
    nextIntelligence: '0oa7rranl46uqDPET297',
    nextPlatform: '0oa7qpab53dsPv6xV297',
  },
  // Of this object, only the values are used; the keys are just for documentation.
  authorizedIssuerIds: {
    default: 'aussrkz0vd8RqqPWo296',
    demo: 'aus1m02r1xcDePqtW297',
  },
  apps: {
    clinicalPortal: 'https://hub.validationtempus.com',
    lens: 'https://lens.validationtempus.com',
    pixelRad: 'https://pixel-rad.validationtempus.com',
    nextIntelligence: 'https://next-intelligence.validationtempus.com',
    nextPlatform: 'https://next-platform.validationtempus.com',
    providerAccount: 'https://provider-account.validationtempus.com',
    ehrIntegrationService: 'https://ehr-integration-service.validationtempus.com',
    progeny2: 'https://progeny2.validationtempus.com',
  },
  sentry: {
    dsn: 'https://5f947265962d3326b3beb95701068c53@o816116.ingest.us.sentry.io/4506792275935232',
    environment: 'val',
    enabled: true,
    release: `${packageJson.name}@${packageJson.version}`,
  },
  // Okta OIDC IdP "Tempus Auth0 Providers - Val" → login.validationtempus.com
  auth0: {
    oktaIdpId: '0oa135ibh4nGKtAb5298',
    sessionInitDomain: 'login.validationtempus.com',
    sessionInitClientId: 'QQ0erpn0ptim7UcnCryK7aP2gBFQZBJA',
    sessionInitConnection: 'TempusAI-WIC',
  },
  whitelistedRedirectDomain: ['.val.gcp.tempus.cloud', '.val.gcp.tempus.cloud', '.validationtempus.com'],
};
